import src from "IMAGE";
export default { src, width: 338, height: 34, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ABwyS3kcMEl6HDFLfBsvRnUqMj1ta0UXXXdLFmJ7TRZji7kI4KuWhiUAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 1 }
